import React from 'react'
import ChevronCircleRight from '/public/assets/svg/chevron_circle_right.svg'
import ChevronCircleLeft from '/public/assets/svg/chevron_circle_left.svg'
import styles from './CarouselV2.module.scss'
import cx from 'classnames'

interface CarouselArrowsProps {
  goToPrev: () => void
  goToNext: () => void
  isAtStart: boolean
  isAtEnd: boolean
  currentSlide: number
  slideCount: number
  useCustomDots?: boolean
  shouldShowArrows?: boolean
  goToSlide?: (slideIndex: number) => void
}

const CarouselArrows: React.FC<CarouselArrowsProps> = ({
  goToPrev,
  goToNext,
  isAtStart,
  isAtEnd,
  currentSlide,
  slideCount,
  useCustomDots = false,
  shouldShowArrows = false,
  goToSlide
}) => {
  const containerClass = cx(styles.arrows, styles['arrowsSurroundDots'])

  // Calculate total number of dots (one per slide)
  const totalDots = slideCount

  return (
    <div className={containerClass}>
      {shouldShowArrows && (
        <button
          className={styles.arrow}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            goToPrev()
          }}
          type='button'
          aria-label={`Previous slide. Currently showing slide ${currentSlide + 1} of ${slideCount}`}
          disabled={isAtStart}
          data-testid='prev-slide-btn'
        >
          <ChevronCircleLeft className={styles.arrowSVG} aria-hidden='true' />
        </button>
      )}
      {useCustomDots && (
        <div className={styles.customDots}>
          {Array.from({ length: totalDots }).map((_, index) => (
            <button
              key={index}
              className={cx(styles.dot, {
                [styles.activeDot]: index === currentSlide
              })}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                if (goToSlide) {
                  goToSlide(index)
                }
              }}
              type='button'
              aria-label={`Go to slide ${index + 1}`}
              aria-current={index === currentSlide ? 'true' : 'false'}
              data-testid={`dot-${index}`}
            />
          ))}
        </div>
      )}
      {shouldShowArrows && (
        <button
          className={styles.arrow}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            goToNext()
          }}
          type='button'
          aria-label={`Next slide. Currently showing slide ${currentSlide + 1} of ${slideCount}`}
          disabled={isAtEnd}
          data-testid='next-slide-btn'
        >
          <ChevronCircleRight className={styles.arrowSVG} aria-hidden='true' />
        </button>
      )}
    </div>
  )
}

export default CarouselArrows
